if ( objects.is_front_page || objects.is_template_front_page ) {
    AOS.init()
    var rellax = new Rellax('.rellax');
}

jQuery(document).ready(function() {
    jQuery(document).scroll(function () {
        var scroll = jQuery(this).scrollTop();
        var topDist = jQuery("#site-header").position();
        if (scroll > topDist.top) {
            jQuery('.logo-text').addClass('hide');
        } else {
            jQuery('.logo-text').removeClass('hide');
        }
    });

    jQuery(".gallery-icon a img").attr('data-fancybox', 'gallery');


});
